import LicenseList from 'components/branch/license/LicenseList';
import LicenseMenu from 'components/branch/license/LicenseMenu';
import MainTitle from 'components/common/admin/MainTitle';
import { useIntl } from 'react-intl';
import "./Conf.scss";

export default function Examtemplate(props: any) {
  const { formatMessage } = useIntl();
  

  return (
    <div className="admin-basic-conf table">
      <MainTitle type="table" title={formatMessage({ id: 'License_1', defaultMessage: '라이선스' })}>
        <LicenseMenu />
      </MainTitle>
      <div className="react-table-area">
        <LicenseList />
      </div>
    </div>
  );
}